// extracted by mini-css-extract-plugin
module.exports = {"topImage":"category-module--topImage--g-l9g"};